export default __webpack_public_path__ + "static/1209-329d41326a61a0604ab8443d22ae92fc.gif";